<div class="not-found-container">
  <div class="not-found-content" data-aos="fade-up">
    <h1 class="not-found-title">{{ 'NOT_FOUND.TITLE' | translate }}</h1>
    <h2 class="not-found-subtitle">{{ 'NOT_FOUND.SUBTITLE' | translate }}</h2>
    <p class="not-found-message">{{ 'NOT_FOUND.MESSAGE' | translate }}</p>
    <a routerLink="/home" class="not-found-button">
      {{ 'NOT_FOUND.BUTTON' | translate }}
    </a>
  </div>
</div>